"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const html2canvas_1 = __importDefault(require("html2canvas"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const MapSideBarPanel_vue_1 = __importDefault(require("@becrop/components/Tracking/Proposals/Playground/Components/MapSideBarPanel.vue"));
const EventTracker_1 = __importDefault(require("@becrop/abstract/Utils/EventTracker"));
let MapSideBarPanelExport = class MapSideBarPanelExport extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.eventTracker = new EventTracker_1.default();
        this.currentExt = 'png';
        this.isLoading = false;
        this.isDownloadFile = false;
    }
    mounted() {
        this.eventTrackerListener('Open export map panel', true);
    }
    eventTrackerListener(eventName, eventValues) {
        this.eventTracker.trackEvent(eventName, eventValues);
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    downloadkml() {
        this.isLoading = true;
        this.isDownloadFile = false;
        this.$emit('onMapExport', this.currentExt);
        // TODO: improve remove timeout
        setTimeout(() => {
            this.isLoading = false;
            this.isDownloadFile = true;
        }, 500);
    }
    downloadImage() {
        const divScreenshot = document.getElementById(`${this.idScreenshot}`);
        (0, html2canvas_1.default)(divScreenshot).then((canvas) => {
            const ext = this.currentExt.toLowerCase();
            const image = canvas.toDataURL(`image/${ext}`);
            const link = document.createElement('a');
            link.href = image;
            link.download = `${this.fileName || '###'}.${ext}`;
            link.click();
        });
        this.isLoading = false;
        this.isDownloadFile = true;
        this.$emit('mapScreenshot', false);
    }
    modelEmitExt(currentExt) {
        this.currentExt = currentExt;
    }
    async download() {
        this.isLoading = true;
        this.isDownloadFile = false;
        this.eventTrackerListener('Download map', true);
        if (this.currentExt.includes('kml')) {
            this.downloadkml();
        }
        else {
            this.downloadImage();
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'single' })
], MapSideBarPanelExport.prototype, "mode", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], MapSideBarPanelExport.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBarPanelExport.prototype, "fileName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], MapSideBarPanelExport.prototype, "idScreenshot", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], MapSideBarPanelExport.prototype, "optionsSelect", void 0);
MapSideBarPanelExport = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            MapSideBarPanel: MapSideBarPanel_vue_1.default,
            SelectField: bmk_ui_framework_1.SelectField,
            Select: bmk_ui_framework_1.Select,
            Button: bmk_ui_framework_1.Button,
            Loading: bmk_ui_framework_1.Loading,
            Ribbon: bmk_ui_framework_1.Ribbon
        },
    })
], MapSideBarPanelExport);
exports.default = MapSideBarPanelExport;
